import { FileText, Image, File, type Icon as PhosphorIcon } from '@phosphor-icons/react';

/**
 * mime/extension → @phosphor-icons/react Icon 매퍼.
 * - application/pdf → FileText
 * - image/* → Image
 * - 그 외 / null / undefined → File (기본)
 *
 * eng-review D4 — shared/lib/file에 정착.
 * 다른 callers(chat 첨부, proof 등)에서도 재사용 가능.
 *
 * 참고: plan D10 결정 시 "lucide-react"로 명시했으나 프로젝트 실제 installed
 * 라이브러리는 phosphor. 같은 icon 패밀리 — 동작 동일, type만 phosphor `Icon` 사용.
 */
export function getFileIcon(mimeType: string | null | undefined): PhosphorIcon {
  if (!mimeType) return File;
  const lower = mimeType.toLowerCase();
  if (lower === 'application/pdf') return FileText;
  if (lower.startsWith('image/')) return Image;
  return File;
}
